// extracted by css-extract-rspack-plugin
export default {"reportList":"ReportList__reportList--aUdyU","headdingWrap":"ReportList__headdingWrap--pKGOh"};